document.addEventListener('DOMContentLoaded', function () {

  const menus = document.querySelectorAll('[data-mega-menu]');
    const desktopMegaQuery = window.matchMedia('(min-width: 768px)');
    let activeMegaPanel = null;
    let overlayHideTimer;
    let megaPageOverlay = document.querySelector('.ki-mega-page-overlay');

    if (!megaPageOverlay) {
      megaPageOverlay = document.createElement('div');
      megaPageOverlay.className = 'ki-mega-page-overlay';
      megaPageOverlay.setAttribute('aria-hidden', 'true');
      document.body.appendChild(megaPageOverlay);
    }

    function hideMegaPageOverlay() {
      activeMegaPanel = null;
      megaPageOverlay.classList.remove('is-active');
      megaPageOverlay.style.removeProperty('top');
    }

    function positionMegaPageOverlay(panel) {
      if (!desktopMegaQuery.matches || !panel) {
        hideMegaPageOverlay();
        return;
      }

      const panelBottom = Math.min(window.innerHeight, Math.max(0, panel.getBoundingClientRect().bottom));
      megaPageOverlay.style.top = panelBottom + 'px';
      megaPageOverlay.classList.add('is-active');
    }

    function showMegaPageOverlay(panel) {
      window.clearTimeout(overlayHideTimer);
      activeMegaPanel = panel;
      window.requestAnimationFrame(function() {
        if (activeMegaPanel === panel && panel.classList.contains('opacity-100')) {
          positionMegaPageOverlay(panel);
        }
      });
    }

    function scheduleMegaPageOverlayHide(panel) {
      if (!desktopMegaQuery.matches || activeMegaPanel !== panel) return;

      window.clearTimeout(overlayHideTimer);
      overlayHideTimer = window.setTimeout(function() {
        if (activeMegaPanel === panel && !panel.classList.contains('opacity-100')) {
          hideMegaPageOverlay();
        }
      }, 0);
    }

    function syncMegaPageOverlay() {
      if (activeMegaPanel && desktopMegaQuery.matches && activeMegaPanel.classList.contains('opacity-100')) {
        positionMegaPageOverlay(activeMegaPanel);
      } else {
        hideMegaPageOverlay();
      }
    }

    window.addEventListener('resize', syncMegaPageOverlay);
    window.addEventListener('scroll', syncMegaPageOverlay, { passive: true });
    desktopMegaQuery.addEventListener('change', syncMegaPageOverlay);

  menus.forEach(function (menu) {

    const panel = menu.querySelector('[data-mega-panel]');
    const caret = menu.querySelector('[data-mega-caret]');
    const trigger = menu.querySelector('[data-mega-trigger]');

    if (!panel || !trigger) return;

      if ('ResizeObserver' in window) {
        new ResizeObserver(syncMegaPageOverlay).observe(panel);
      }

      panel.addEventListener('transitionend', function(event) {
        if (event.propertyName === 'transform' || event.propertyName === 'opacity') {
          syncMegaPageOverlay();
        }
      });

    let closeTimer;


    function closeMenu() {
        scheduleMegaPageOverlayHide(panel);

      panel.classList.add(
        'pointer-events-none',
        'translate-y-2',
        'opacity-0'
      );

      panel.classList.remove(
        'pointer-events-auto',
        'translate-y-0',
        'opacity-100'
      );

      if (caret) {
        caret.classList.remove('rotate-180');
      }

    }


    function openMenu() {
        showMegaPageOverlay(panel);

      window.clearTimeout(closeTimer);

      menus.forEach(function (otherMenu) {

        if (otherMenu !== menu) {
          otherMenu.dispatchEvent(
            new CustomEvent('mega-menu-close')
          );
        }

      });

      panel.classList.remove(
        'pointer-events-none',
        'translate-y-2',
        'opacity-0'
      );

      panel.classList.add(
        'pointer-events-auto',
        'translate-y-0',
        'opacity-100'
      );

      if (caret) {
        caret.classList.add('rotate-180');
      }

    }


    function scheduleClose() {

      window.clearTimeout(closeTimer);

      closeTimer = window.setTimeout(
        closeMenu,
        220
      );

    }


    menu.addEventListener(
      'mega-menu-close',
      closeMenu
    );

    menu.addEventListener(
      'mouseenter',
      openMenu
    );

    menu.addEventListener(
      'mouseleave',
      scheduleClose
    );

    panel.addEventListener(
      'mouseenter',
      openMenu
    );

    panel.addEventListener(
      'mouseleave',
      scheduleClose
    );

    trigger.addEventListener(
      'focus',
      openMenu
    );

    menu.addEventListener(
      'focusout',
      function (event) {

        if (!menu.contains(event.relatedTarget)) {
          scheduleClose();
        }

      }
    );

  });

  function applyFooterMegaMenuIcons() {

    const footer = document.querySelector('.ki-footer');

    if (!footer) return;

    const footerItems = footer.querySelectorAll(
      '.ki-mega-menu-item[data-footer-icon]'
    );

    footerItems.forEach(function (item) {

      const footerIconUrl = (
        item.getAttribute('data-footer-icon') || ''
      ).trim();
      const footerIconAlt = (item.getAttribute('data-footer-icon-alt') || '').trim();

      if (!footerIconUrl) return;


      const iconWrap = item.querySelector(
        '.ki-mega-menu-icon-wrap'
      );

      if (!iconWrap) return;


      let image = iconWrap.querySelector(
        '.ki-mega-menu-icon'
      );

      if (image) {

        image.removeAttribute('srcset');
        image.removeAttribute('sizes');

        image.src = footerIconUrl;
      image.alt = footerIconAlt;

        return;
      }

      const placeholder = iconWrap.querySelector(
        '.ki-mega-menu-icon-placeholder'
      );

      if (placeholder) {

        image = document.createElement('img');

        image.src = footerIconUrl;
        image.alt = footerIconAlt;
        image.width = 32;
        image.height = 32;
        image.className = 'ki-mega-menu-icon';

        placeholder.replaceWith(image);

      }

    });

  }
  applyFooterMegaMenuIcons();

  /*
   * Keep footer-specific icons applied before the browser paints.
   * The old 50ms / 100ms delays could briefly expose the header icon
   * whenever footer markup was refreshed while scrolling.
   */
  const footerIconObserver = new MutationObserver(
    function () {
      applyFooterMegaMenuIcons();
    }
  );

  footerIconObserver.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );

  document.addEventListener(
    'shopify:section:load',
    function () {
      applyFooterMegaMenuIcons();
    }
  );

  /*
   * Some theme/footer behavior can refresh or restore shared mega-menu
   * markup during scrolling. Re-apply the footer icon in the same frame,
   * after scroll handlers have run and before paint, so the header icon
   * never flashes in the footer.
   */
  let footerIconScrollFrame = null;

  window.addEventListener(
    'scroll',
    function () {
      if (footerIconScrollFrame !== null) return;

      footerIconScrollFrame = window.requestAnimationFrame(function () {
        applyFooterMegaMenuIcons();
        footerIconScrollFrame = null;
      });
    },
    { passive: true }
  );

});

document.addEventListener('DOMContentLoaded', function () {
  const mobileMenuQuery = window.matchMedia('(max-width: 767px)');

  document.querySelectorAll('[data-mobile-menu-panel]').forEach(function (panel) {
    const menu = panel.closest('[data-mega-menu]');
    const trigger = menu && menu.querySelector('[data-mega-trigger]');
    const closeButton = panel.querySelector('[data-mobile-menu-close]');

    if (!trigger) return;

    trigger.setAttribute('aria-controls', panel.id);
    trigger.setAttribute('aria-expanded', 'false');

    function isMobileMenu() {
      return mobileMenuQuery.matches;
    }

    function closeMobileMenu() {
      panel.classList.remove('ki-mobile-menu-is-open');
      panel.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('ki-mobile-menu-open');
      document.body.classList.remove('ki-mobile-menu-open');
    }

    function openMobileMenu() {
      document.querySelectorAll('[data-mobile-menu-panel]').forEach(function (otherPanel) {
        if (otherPanel !== panel) otherPanel.classList.remove('ki-mobile-menu-is-open');
      });
      panel.classList.add('ki-mobile-menu-is-open');
      panel.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('ki-mobile-menu-open');
      document.body.classList.add('ki-mobile-menu-open');
      if (closeButton) closeButton.focus({ preventScroll: true });
    }

    if (isMobileMenu()) panel.setAttribute('aria-hidden', 'true');

    trigger.addEventListener('click', function (event) {
      if (!isMobileMenu()) return;
      event.preventDefault();
      panel.classList.contains('ki-mobile-menu-is-open') ? closeMobileMenu() : openMobileMenu();
    });

    if (closeButton) closeButton.addEventListener('click', closeMobileMenu);

    panel.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        if (isMobileMenu()) closeMobileMenu();
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && isMobileMenu() && panel.classList.contains('ki-mobile-menu-is-open')) {
        closeMobileMenu();
        trigger.focus({ preventScroll: true });
      }
    });

    mobileMenuQuery.addEventListener('change', function () {
      if (isMobileMenu()) {
        panel.setAttribute('aria-hidden', 'true');
      } else {
        closeMobileMenu();
        panel.removeAttribute('aria-hidden');
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const mobileMenuGridQuery = window.matchMedia('(max-width: 767px)');

  document.querySelectorAll('[data-mobile-menu-panel] .ki-mega-menu-grid').forEach(function (grid) {
    const columns = Array.from(grid.querySelectorAll(':scope > .ki-mega-menu-column'));
    const drawerHeader = grid.previousElementSibling;
    const originalColumns = columns.map(function (column) {
      return { column: column, items: Array.from(column.querySelectorAll(':scope > .ki-mega-menu-item')) };
    });

    function updateMobileGrid() {
      if (mobileMenuGridQuery.matches) {
        if (drawerHeader) drawerHeader.style.display = 'flex';
        originalColumns.forEach(function (group) {
          group.items.forEach(function (item) { grid.appendChild(item); });
        });
        columns.forEach(function (column) { column.style.display = 'none'; });
        grid.classList.add('ki-mobile-menu-flat');
      } else {
        if (drawerHeader) drawerHeader.style.display = 'none';
        originalColumns.forEach(function (group) {
          group.items.forEach(function (item) { group.column.appendChild(item); });
        });
        columns.forEach(function (column) { column.style.removeProperty('display'); });
        grid.classList.remove('ki-mobile-menu-flat');
      }
    }

    updateMobileGrid();
    mobileMenuGridQuery.addEventListener('change', updateMobileGrid);
  });
});
